"use strict";

import angular from "angular";

import uiRouter from "angular-ui-router";

import routing from "./account.routes";
import settings from "./settings";
import forgotten from "./forgotten";
import signup from "./signup";
import contact from "./contact";
import legal from "./legal";

export default angular
  .module("dalApp.account", [
    uiRouter,
    settings,
    forgotten,
    signup,
    contact,
    legal,
  ])
  .config(routing)
  .run(function ($rootScope) {
    "ngInject";

    $rootScope.$on(
      "$stateChangeStart",
      function (event, next, nextParams, current) {
        if (
          next.name === "logout" &&
          current &&
          current.name &&
          !current.authenticate
        ) {
          next.referrer = current.name;
        }
      }
    );
  }).name;



// WEBPACK FOOTER //
// ./client/app/account/index.js